export default __webpack_public_path__ + "static/media/R_wdt_c_cap_3.6b4f8679.mp3";